import { DialogSize } from '@thyme/nashville/src/types/dialogs'
import { storeToRefs } from 'pinia'
import { computed, ExtractPropTypes, ref, SetupContext } from 'vue'
import { usePatientStore } from '@/legacy/store/modules/patient'
import { useFlagStore } from '@/store/flags/flags'
import { ASK_LLMS_MODAL_PROPS, LLM_TAB, LlmTab } from './types'

type AskLlmsModalProps = ExtractPropTypes<typeof ASK_LLMS_MODAL_PROPS>

/**
 * Controller for AskLlmsModal — returns reactive state for the component template
 * @param props
 * @param context
 */
export default function (props: AskLlmsModalProps, context: SetupContext) {
  const { showAskAProfile } = storeToRefs(useFlagStore())

  const tabs = [
    {
      label: 'Ask Thyme Box',
      icon: 'documentPlus',
      value: LLM_TAB.ASK_THYME_BOX,
    },
    { label: 'Ask Profile', icon: 'userCircle', value: LLM_TAB.ASK_A_PROFILE },
    {
      label: 'Connect Articles',
      icon: 'bookOpen',
      value: LLM_TAB.CONNECT_ARTICLES,
    },
  ]

  const activeTab = ref<LlmTab>(props.defaultTab)
  const activeTabIndex = ref<number>(
    tabs.findIndex((tab) => tab.value === props.defaultTab)
  )

  const { patient, person } = storeToRefs(usePatientStore())
  // PatientStore can be stale, so we check if the person matches the patientId coming from the route
  const validatedPerson = computed(() =>
    props.patientId === person.value?.entityId ? person.value : null
  )

  const externalThymeboxPatientId = computed(() => {
    // When the store’s patient doesn’t match this modal’s patientId, treat as empty
    if (props.patientId !== patient.value?.entityId) {
      return undefined
    }

    return patient.value?.externalId?.externalThymeboxPatientId ?? undefined
  })

  /**
   *
   * @param tab
   * @param tab.index
   */
  function onTabChange(tab: { index: number }) {
    activeTabIndex.value = tab.index
    activeTab.value = tabs[tab.index].value
  }

  /**
   *
   * @param e
   */
  function swallowEvent(e: MouseEvent) {
    e.preventDefault()
    e.stopPropagation()
  }

  /**
   *
   */
  function close() {
    context.emit('close')
  }

  return {
    activeTab,
    activeTabIndex,
    LLM_TAB,
    items: tabs,
    onTabChange,
    close,
    DialogSize,
    showAskAProfile,
    isOpen: computed(() => props.isOpen),
    showDevTools: computed(() => props.showDevTools),
    validatedPerson,
    externalThymeboxPatientId,
    swallowEvent,
  }
}
